// removed by extract-text-webpack-plugin
module.exports = {"mobile-s":"320px","mobile":"480px","mobile-l":"640px","ipad-portrait":"768px","ipad":"1024px","desktop-s":"1280px","desktop":"1366px","large":"1600px","extra-large":"1920px"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/styles/_breakpoints.css
// module id = 665
// module chunks = 0